import type { SocketEventListener } from '@/shared/api';
import { EMITTER_CONSTANTS } from '@/shared/config';
import emitter from '@/shared/lib/eventEmitter';

const inboxRealtimeListeners: SocketEventListener[] = [
  {
    event: 'inbox',
    handler: (msg: any) => {
      console.log('socket io - inboxListener', msg);
      emitter.emit(EMITTER_CONSTANTS.INBOX_EVENTS, msg);
    },
  },
  {
    event: 'markInbox',
    handler: (msg: any) => {
      console.log('socket io - markInboxListener', msg);
      emitter.emit(EMITTER_CONSTANTS.MARK_INBOX_EVENT, msg);
    },
  },
  {
    event: 'reportUpdated',
    handler: (msg: any) => {
      console.log('socket io - reportUpdatedListener', msg);
      emitter.emit(EMITTER_CONSTANTS.REPORT_UPDATED, msg);
    },
  },
  {
    event: 'markStatusReport',
    handler: (msg: any) => {
      console.log('socket io - markStatusReportListener', msg);
      emitter.emit(EMITTER_CONSTANTS.MARK_STATUS_REPORT, msg);
    },
  },
  {
    event: 'instantReportUpdated',
    handler: (msg: any) => {
      console.log('socket io - instantReportUpdatedListener', msg);
      emitter.emit(EMITTER_CONSTANTS.INSTANT_REPORT_UPDATED, msg);
    },
  },
];

export default inboxRealtimeListeners;
